import { submitFormData, submitJsonData, submitMultipartFormData, requestJson } from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
* @param body: {pwd,account}
* @returns Promise
*/
export function login(body) {

    return new Promise((resolve, reject) => {

        submitFormData({
            url: '/api/login',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

/**
* @param body: {pwd,account}
* @returns Promise
*/
export function wxLogin(body) {

    return new Promise((resolve, reject) => {

        submitFormData({
            url: '/ssoapi/wxpc/auth',
            urlParams: body,
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

/**
* @param body: {pwd,account}
* @returns Promise
*/
export function wxBind(body) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/ssoapi/wxpc/bind',
            bodyParams: body,
            headers: { sso_token: body.sso_token }
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

/**
* @param body: {pwd,account}
* @returns Promise
*/
export function getImg(body) {
    return new Promise((resolve, reject) => {
        requestJson({
            url: '/ssoapi/captcha/imagecode',
        }).then(
            result => {
                resolve(result);
            },
            error => {
                reject(error)
            }
        );
    });
}

/**
* @param body: {}
* @returns Promise
*/
export function loginOut(body) {

    return new Promise((resolve, reject) => {

        submitFormData({
            url: '/api/loginOut',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

/**
* @param body: {}
* @returns Promise
*/
export function getLoginUser(body) {

    return new Promise((resolve, reject) => {

        submitFormData({
            url: '/api/getLoginUser',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

/**
* @param body: {}
* @returns Promise
*/
export function getPhoneMobile(body) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/ssoapi/captcha/smscode',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

/**
* @param body: {}
* @returns Promise
*/
export function forgetpwd(body) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/ssoapi/user/forgetpwd',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );

    });
}

